import { BASE_URL_API } from 'constants/base-url-default'
import { getCookie } from 'utils/functions-cookie'

export const addMassiveEmployees = async (
  body: FormData,
  company_id: string,
) => {
  const authToken = getCookie('auth_token')

  if (!authToken) {
    throw new Error('Você não está autenticado.')
  }

  const response = await fetch(
    `${BASE_URL_API}/companies/${company_id}/employees/bulk`,
    {
      method: 'POST',
      headers: {
        Authorization: `Bearer ${authToken}`,
        'Access-Control-Allow-Origin': '*',
      },
      body,
    },
  )

  return response.status
}
